import { render, staticRenderFns } from "./teamOfferDetail.vue?vue&type=template&id=5a288024&scoped=true"
import script from "./teamOfferDetail.vue?vue&type=script&lang=js"
export * from "./teamOfferDetail.vue?vue&type=script&lang=js"
import style0 from "./teamOfferDetail.vue?vue&type=style&index=0&id=5a288024&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./teamOfferDetail.vue?vue&type=style&index=1&id=5a288024&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a288024",
  null
  
)

export default component.exports